import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationsStore } from '../annotations.store';
import { StatsProgress } from '../components/StatsProgress';

export const AnnotationProgressContainer = observer((): ReactElement => {
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const { t } = useTranslator();
  const { you, all, totalImages } = annotationsStore.annotationProgress;

  return (
    <StatsProgress
      header={t('annotation_progress')}
      stats={[
        { label: t('annotated_by_you'), value: you.toString() },
        { label: t('annotated_by_all'), value: all.toString() },
        { label: t('images_in_total'), value: totalImages.toString() },
      ]}
    />
  );
});
